import React from "react";
import styles from "./styles.module.scss";
import { useAppTranslation } from "../../../../../../../../../i18n/useAppTranslation";
import { useDebouncedInputHandle } from "../../../../../../../../../helpers/hooks/useDebouncedInputHandle";

export const InputDescription = ({ value, onChange }) => {
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "survey",
  });

  const { inputValue, setInputValue } = useDebouncedInputHandle({
    value,
    onChange,
  });

  return (
    <input
      className={styles.root}
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      placeholder={t("content.placeholder.description")}
    />
  );
};
